import { effectiveEnergy, type Energy } from '@hmawiw/shared';
import { useState } from 'react';
import { useNow } from '../../hooks/useMedia';
import { useT } from '../../i18n';
import { haptic } from '../../native/platform';
import { useEvents } from '../../store/events';
import { useSettings } from '../../store/settings';
import controls from '../controls.module.css';
import { EnergyGlyph } from '../icons';
import { Sheet } from '../Sheet/Sheet';
import styles from './EnergyLens.module.css';

const LEVELS: Energy[] = [1, 2, 3];

/** One battery in the middle of the top bar: a tap opens the choice, so only a chosen level is ever recorded. */
export function EnergyLens() {
  const t = useT();
  const now = useNow();
  const energyNow = useSettings((s) => s.energyNow);
  const setSetting = useSettings((s) => s.set);
  const log = useEvents((s) => s.log);
  const [open, setOpen] = useState(false);
  const level = effectiveEnergy(energyNow, now) ?? 0;
  const name = level === 0 ? t.t('lens.none') : t.t(`energy.${level}`);
  const label = t.t('lens.cycle', { level: name });
  const choose = (next: Energy | 0) => {
    haptic('tick');
    void setSetting('energyNow', next === 0 ? null : { level: next, setAt: Date.now() });
    void log('energy', null, { level: next });
    setOpen(false);
  };
  return (
    <>
      <button type="button" className={`${styles.cycle}${level === 0 ? ` ${styles.unset}` : ''}`} onClick={() => setOpen(true)} aria-label={label} title={label} data-level={level}>
        <EnergyGlyph level={level} size={22} />
      </button>
      <Sheet open={open} label={t.t('lens.label')} onClose={() => setOpen(false)}>
        <div className={controls.group}>
          <div className={controls.label}>{t.t('lens.label')}</div>
          <div className={controls.chips} role="group" aria-label={t.t('lens.label')}>
            {LEVELS.map((l) => (
              <button key={l} type="button" className={controls.chip} aria-pressed={level === l} onClick={() => choose(l)}>
                <EnergyGlyph level={l} size={18} />
                {t.t(`energy.${l}`)}
              </button>
            ))}
          </div>
          <span className={styles.hint}>{t.t('lens.hint')}</span>
        </div>
        <div className={controls.footer}>
          <button type="button" className={`${controls.btn} ${controls.quiet}`} disabled={level === 0} onClick={() => choose(0)}>
            {t.t('lens.clear')}
          </button>
        </div>
      </Sheet>
    </>
  );
}
